import { render, staticRenderFns } from "./BatchForceImport.vue?vue&type=template&id=34b6d0be&scoped=true"
import script from "./BatchForceImport.vue?vue&type=script&lang=js"
export * from "./BatchForceImport.vue?vue&type=script&lang=js"
import style0 from "./BatchForceImport.vue?vue&type=style&index=0&id=34b6d0be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b6d0be",
  null
  
)

export default component.exports